// @todo: Migrate to 'Dialog.Alert' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Alert} from '@wandb/weave/components/Alert';
import {Explorer} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/inference/Explorer';
import {useInferenceContext} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/inference/util';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useEffect} from 'react';
import {useParams} from 'react-router';

import {setDocumentTitle} from '../util/document';
import {InferenceProvider} from './InferenceContext';

type InferenceParams = {
  collectionId?: string;
};

const style = {
  width: '100%',
  height: '100%',
};

const InferencePage = () => {
  return (
    <InferenceProvider>
      <Tailwind style={style}>
        <InferencePageInner />
      </Tailwind>
    </InferenceProvider>
  );
};

const InferencePageInner = () => {
  const context = useInferenceContext();

  const {collectionId} = useParams<InferenceParams>();

  const pageTitle = collectionId
    ? `Inference - ${collectionId}`
    : 'W&B hosted models';
  useEffect(() => {
    setDocumentTitle(pageTitle);
  }, [pageTitle]);

  if (!context.isCatalogEnabled) {
    return (
      <div className="m-24">
        <Alert severity="info">{context.availabilityMessage}</Alert>
      </div>
    );
  }

  return <Explorer collectionId={collectionId} inferenceContext={context} />;
};

export default InferencePage;
